











import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import EmptyHeader from '../components/UI/header/EmptyHeader.vue'
import PortalName from '@/utils/PortalName'

const user = namespace('user')
const BLOCK_SELECTOR = 'private-layout'

@Component({
    components: {
        EmptyHeader,
    },
})
export default class PrivateLayoutBasic extends Vue {
    @Prop({ type: String, default: 'sm' }) extended!: 'sm' | 'md' | 'lg' | 'xl'
    @Prop({ type: String, default: 'lead' }) menu!: 'lead' | 'disabled-member'
    @Prop({ type: String, default: '' }) afterLoginRedirect!: string
    @Prop() backgroundImage!: string
    @user.Getter isConnected!: boolean
    PortalName: typeof PortalName = PortalName

    get bgClassList() {
        const blockSelector = `${BLOCK_SELECTOR}__bg`

        return [blockSelector, this.extended]
    }

    get bgStyle() {
        if (!this.backgroundImage) {
            return null
        }

        return {
            'background-image': `linear-gradient(var(--primary), transparent 200%) ,url(${this.backgroundImage})`,
        }
    }
}
